import Auth from './auth/reducer';
import App from './app/reducer';

export default {
  Auth,
  App,
};
